import React from "react";
import Icon from "../shared/Icon";
import Text from "../shared/Text";
import { PanelContext } from "../../contexts/PanelContext";
import styled, { css } from "styled-components";
import { buttonReset } from "../../utils/theme";

const CloseButton: React.FC<{ marginTop?: boolean }> = (props) => {
  const [panel, setPanel] = React.useContext(PanelContext);

  return (
    <StyledCloseButton
      style={{ marginTop: props.marginTop ? "2rem" : "0" }}
      tabIndex={panel.open ? 0 : -1}
      onClick={() => {
        setPanel({ ...panel, open: false });
      }}
    >
      <Icon icon="back" hoverColor={"accent"} />
      <Text as="h4">Back to map</Text>
    </StyledCloseButton>
  );
};

const StyledCloseButton = styled.button`
  ${({ theme }) => css`
    ${buttonReset}
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    h4 {
      padding-left: 0.5rem;
    }
    * {
      transition: color ease-in-out 0.3s, fill ease-in-out 0.1s;
    }
    :hover,
    :focus {
      * {
        color: ${theme.colors.accent};
        fill: ${theme.colors.accent};
      }
    }
  `}
`;

export default CloseButton;
